/** Web preview of backend/src/modules/quality/iqc-bands.ts evaluateSample — server is authoritative. */
export interface IqcParam { key: string; label: string; type: 'number' | 'text' | 'pass_fail'; min: number | null; max: number | null; unit: string | null; acceptValues: string[] | null; specText: string }
export type IqcSample = number | string | boolean | null;

export function evaluateSample(param: IqcParam, sample: IqcSample): 'in' | 'out' | 'missing' {
  if (sample === null || sample === undefined || (typeof sample === 'string' && sample.trim() === '')) return 'missing';
  if (param.type === 'number') {
    const n = Number(sample);
    if (!Number.isFinite(n)) return 'out';
    if (param.min !== null && n < param.min) return 'out';
    if (param.max !== null && n > param.max) return 'out';
    return 'in';
  }
  if (param.type === 'pass_fail') return ['pass', 'true'].includes(String(sample).toLowerCase()) ? 'in' : 'out';
  if (!param.acceptValues) return 'in';
  return param.acceptValues.some((a) => a.toLowerCase() === String(sample).trim().toLowerCase()) ? 'in' : 'out';
}
